import { GraduationCap, MapPin, Wrench, MessageSquare } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
    {
        icon: GraduationCap,
        title: "Formação Técnica em TADS",
        text: "Atendimento direto com profissional formado em Análise e Desenvolvimento de Sistemas. Você fala com quem entende de código e arquitetura — sem suporte amador.",
    },
    {
        icon: MapPin,
        title: "Presença Local no Campo Limpo",
        text: "Estamos na Zona Sul de São Paulo. Em uma emergência com computadores ou rede, o deslocamento até você é rápido.",
    },
    {
        icon: Wrench,
        title: "Soluções Sob Medida para o Bairro",
        text: "Entendemos a realidade do comércio local: preços justos, sem contratos mirabolantes e com retorno prático desde o primeiro dia.",
    },
    {
        icon: MessageSquare,
        title: "Contato Direto sem Burocracia",
        text: "Nada de tickets demorados ou robôs de atendimento. Você manda mensagem no WhatsApp e é respondido por uma pessoa real.",
    },
];

export const WhyChoose = () => (
    <section id="sobre" data-testid="why-choose-section" className="relative overflow-hidden py-24 sm:py-32">
        <div className="bg-grid grid-fade absolute inset-0 opacity-60" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
            <div className="grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr]">
                <Reveal>
                    <div className="relative">
                        <div className="overflow-hidden rounded-3xl border border-white/10">
                            <img
                                src="https://images.unsplash.com/photo-1515879218367-8466d910aaa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxwcm9ncmFtbWluZyUyMGNvZGUlMjBzY3JlZW58ZW58MHx8fHwxNzkwMzgwMjkwfDA&ixlib=rb-4.1.0&q=85"
                                alt="Tela de editor com código de programação colorido — desenvolvimento Strondex Tech"
                                loading="lazy"
                                className="h-[420px] w-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#07090E] via-transparent to-transparent" />
                        </div>
                        <div className="absolute bottom-5 left-5 right-5 rounded-2xl border border-white/10 bg-[#0D121F]/85 p-5 backdrop-blur-xl">
                            <div className="flex items-center gap-3">
                                <span className="beacon-dot h-2.5 w-2.5 shrink-0 rounded-full bg-[#25D366]" />
                                <p className="text-sm font-semibold text-slate-200">
                                    Base no Campo Limpo — atendimento em toda a Zona Sul de SP
                                </p>
                            </div>
                        </div>
                    </div>
                </Reveal>

                <div>
                    <Reveal>
                        <span className="text-xs font-bold uppercase tracking-[0.24em] text-cyan-400">
                            Sobre a Strondex Tech
                        </span>
                        <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl">
                            Por que escolher a Strondex Tech?
                        </h2>
                        <p className="mt-4 text-base text-slate-400 sm:text-lg">
                            A união entre conhecimento acadêmico sólido e a agilidade
                            de um parceiro vizinho ao seu comércio.
                        </p>
                    </Reveal>
                    <div className="mt-10 grid gap-4 sm:grid-cols-2">
                        {ITEMS.map((item, i) => (
                            <Reveal key={item.title} delay={i * 0.1}>
                                <div
                                    data-testid={`why-item-${i}`}
                                    className="group h-full rounded-2xl border border-white/[0.07] bg-[#111827] p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-cyan-400/40 hover:shadow-[0_12px_36px_rgba(0,136,255,0.12)]"
                                >
                                    <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-400/20 bg-cyan-400/[0.08] transition-colors duration-300 group-hover:bg-cyan-400/[0.15]">
                                        <item.icon size={20} className="text-cyan-300" />
                                    </span>
                                    <h3 className="mt-4 text-base font-bold text-slate-100">
                                        {item.title}
                                    </h3>
                                    <p className="mt-2 text-sm leading-relaxed text-slate-400">
                                        {item.text}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);
